module.exports = __webpack_public_path__ + "img/rytblx9.06c99545.png";